module.exports = __webpack_public_path__ + "img/483.3cb6be08.jpg";